import React from 'react';
import PropTypes from 'prop-types';
import ContainerDimensions from 'react-container-dimensions';
import { Container, Row, Col, ScreenClassRender } from 'react-grid-system';
import classNames from 'classnames/bind';

import styles from './MenuSetRight.module.scss';
import SectionTitle from '../../misc/SectionTitle';
import Paragraph from '../../misc/Paragraph';

const cx = classNames.bind(styles);

const MenuSetRight = ({ engTitle, korTitle, image, content, children }) => (
  <Container className={cx('container')}>
    <Row align="center">
      <Col xs={12} lg={3} offset={{ lg: 1 }}>
        <ScreenClassRender render={(screenClass) => {
          const isMobile = ['xs', 'sm', 'md'].includes(screenClass);

          return (
            <div className={cx(['content', { mobile: isMobile }])}>
              <SectionTitle
                title={engTitle}
                subtitle={<span>{korTitle}</span>}
              />
              <Paragraph>{content}</Paragraph>
            </div>
          );
        }} />
        {children}
      </Col>
      <Col xs={12} lg={8}>
        <ContainerDimensions>
          {({ width }) => {
            const height = width * 2 / 3;

            return (
              <div style={{ height }} className={cx('imageWrapper')}>
                <img src={image} alt={korTitle} width="100%" />
              </div>
            );
          }}
        </ContainerDimensions>
      </Col>
      </Row>
  </Container>
);

MenuSetRight.propTypes = {
  engTitle: PropTypes.string.isRequired,
  korTitle: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
};

export default MenuSetRight;